module.exports = __webpack_public_path__ + "img/c979e198629182a782fea6e8b94d7e1a.png";